export const barscanWarehouseDespatchStatusKeys = [
  "newRequest",
  "printedPicking",
  "pickedWaitingDespatch",
  "despatched",
  "inTransit",
  "completed",
  "cancelled",
] as const

export type IBarscanWarehouseDespatchStatusKey = (typeof barscanWarehouseDespatchStatusKeys)[number]

/** Display labels matching BarscanStatus TransferStatus enum. */
export const barscanWarehouseDespatchStatusLabels: Record<
  IBarscanWarehouseDespatchStatusKey,
  string
> = {
  newRequest: "New Request",
  printedPicking: "Printed Picking",
  pickedWaitingDespatch: "Picked Waiting Despatch",
  despatched: "Despatched",
  inTransit: "In Transit",
  completed: "Completed",
  cancelled: "Cancelled",
}

/** Map Barscan statusID → stable key (same order as BarscanStatus UI). */
export function barscanStatusIdToKey(statusId: number): IBarscanWarehouseDespatchStatusKey | null {
  return barscanWarehouseDespatchStatusKeys[statusId] ?? null
}

/** Furthest-along status among deliveries (max statusID). */
export function maxBarscanWarehouseDespatchStatusKey(
  statusIds: number[],
): IBarscanWarehouseDespatchStatusKey | "" {
  const valid = statusIds.filter(id => barscanStatusIdToKey(id) != null)
  if (valid.length === 0) {
    return ""
  }
  const maxId = Math.max(...valid)
  return barscanStatusIdToKey(maxId) ?? ""
}

export function barscanWarehouseDespatchStatusLabel(
  status: string | null | undefined,
): string | null {
  if (!status) {
    return null
  }
  return barscanWarehouseDespatchStatusLabels[status as IBarscanWarehouseDespatchStatusKey] ?? null
}
